import { render, staticRenderFns } from "./DirectPaymentModal.vue?vue&type=template&id=2668ca13&scoped=true"
import script from "./DirectPaymentModal.vue?vue&type=script&lang=js"
export * from "./DirectPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./DirectPaymentModal.vue?vue&type=style&index=0&id=2668ca13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668ca13",
  null
  
)

export default component.exports